import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mb-6">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-600 md:text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.path && !isLast ? (
                <Link to={item.path} className="cursor-pointer transition-colors hover:text-primary-700">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-800' : ''} aria-current={isLast ? 'page' : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span className="flex h-3 w-3 items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-s-line text-sm" />
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}